import { FC } from 'react';

import CapsulePriceListing from 'components/main/CapsulePrice/index';

const CapsulePrice: FC = () => <CapsulePriceListing />;

export default CapsulePrice;
